import { fileExtensionMarkdown, fileNameExtensionEnsure, fileNameExtensionRemove, fileNamePrefixFolder } from "@cer/cer-form/cer-form-view-type/cer-form-view-type-document/cer-form-view-document-type";

export const docNameDefault = 'doc.md';

type LinkProtocolDocType = 'http' | 'app' | 'doc';

export class CerLink {
    public protocol?: string;
    public url: string;
    public id?: string;
    public title: string;

    public init(asDoc: boolean, asApp: boolean = false) {
        this.initUrl(asDoc, asApp);
        if (this.url?.startsWith("/")) {
            this.url = this.url.substring(1);
        }
    }

    private initUrl(asDoc: boolean, asApp: boolean = false) {
        // Translate link URL using protocols+parameters
        if (this.url.startsWith('doc/')) {
            this.url = this.url.replace('doc/','doc:')
        }
        if (this.url.startsWith('app/')) {
            this.url = this.url.replace('app/','app:')
        }
        var parts = this.url?.split(':');
        if (parts.length <= 1) {
            return;
        }
        const protocol : string = parts[0].toLocaleLowerCase() as LinkProtocolDocType;
        
        if (!(protocol?.length > 0)) {
            this.url = fileNameExtensionEnsure(this.url, fileExtensionMarkdown);
            return;
        }
        if (protocol.startsWith('http')) {
            this.protocol = 'http';
            return;
        }

        parts.shift(); // remove protocol from url
        this.url = parts.join(":");

        if (protocol == 'app') {
            if (asDoc)
            {
                this.protocol = 'doc';
                this.url= fileNameExtensionEnsure(this.url, fileExtensionMarkdown);
            }
            else {
                this.protocol = 'app';
                this.url= fileNameExtensionRemove(this.url);
            }
        }
        else if (protocol == 'doc') {
            // Route document can open original route if requested
            if (asApp === true) {
                this.protocol = "app";
                this.url = fileNameExtensionRemove(this.url);
            }
            else {
                this.protocol = 'doc';
            }
        }
        if (this.protocol == 'app') {
            this.url = fileNameExtensionRemove(this.url);
        }
        else {
            this.url = fileNameExtensionEnsure(this.url, fileExtensionMarkdown);
            if (protocol.length > 0 && protocol != 'app') {
                this.url = fileNamePrefixFolder(protocol,this.url); // Documentation for routes is stored in the folder "doc"
            }
        }
    }
}
